import { combineReducers } from "redux";

import { appReducer } from "./app/appReducer";
import { chromiaReducer } from "./chromia/chromiaReducer";
import { UIReducer } from "./UI/UIReducer";
import { modalsReducer } from "./modals/modalsReducer";


export const rootReducer = combineReducers({
	app: appReducer,
	modals: modalsReducer,
	UI: UIReducer,
	chromia: chromiaReducer
});